import { Alert, AlertProps, Text } from "@mantine/core"

export function InfoAlert({ children, ...props }: AlertProps) {
  return (
    <Alert color="gray" {...props}>
      {typeof children === "string" ? <Text>{children}</Text> : children}
    </Alert>
  )
}
